import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from '../../pipes/pipes.module';
import { OrdersModalComponent } from './orders-modal.component';
import { FormsModule } from '@angular/forms';
import { InputModalModule } from '../input-modal/input-modal.module';
import { SharedModule } from '../shared.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, IonicModule, PipesModule, FormsModule, InputModalModule, TranslateModule],
  declarations: [OrdersModalComponent],
  exports: [OrdersModalComponent]
})
export class OrdersModalModule {}
